var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.value),expression:"value"}]},[_c('icon',{staticClass:"has-text-grey",attrs:{"icon":"plug"}}),_vm._v(" "+_vm._s(_vm.value)+" mV ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }